<template>
	<div v-if="tabs" class="m-detail-content">
		<c-tab-list :tabs="tabs" @change="item => currentTab = item.value"></c-tab-list>

		<template v-for="(item, i) in tabs">
			<div v-show="currentTab == item.value" :key="i" class="m-detail-content-item">
				<slot :name="item.value"></slot>
			</div>
		</template>
	</div>
	<div v-else class="m-detail-content">
		<div class="m-detail-content-item">
			<slot></slot>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'detailContent',

		props: {
			tabs: Array
		},

		data() {
			return {
				currentTab: ''
			}
		}
	}
</script>

<style lang="stylus" scoped>
	.m-detail-content {
		border-radius: .16rem;
		margin: 0 .2rem .2rem;
		overflow: hidden;
		background: #fff;

		&:nth-child(1) {
			margin-top: .2rem;
		}

		>>> > .c-tab-list {
			ul {
				border-color: #eee;

				li {
					flex-grow: 1;
					padding: 0;

					&:after {
						background: #000;
					}
				}
			}
		}

		&-item {
			padding: 0 .2rem .24rem;

			>>> .c-title p {
				margin: .35rem 0 .25rem;
			}
			
			>>> .c-detail {
				padding: 0;
				background: #fff;

				&-content {
					border-color: #eee;
				}

				&-item {
					border-color: #eee;

					&-label {
						box-sizing: border-box;
						width: 2.2rem;
						border-color: #eee;
						padding: .16rem .12rem;
						font-size: .28rem;
						color: #91A1B9;
						background: #F9F9F9;
					}

					&-content {
						padding: .16rem .12rem;
					}
				}
			}
			
			>>> .c-scroll-list-main .c-empty {
				position: relative !important;
				transform: none !important;
			}

			>>> .card {
				margin: .16rem 0 0;
				background: #F9F9F9;
			}
		}
	}
</style>
